/* global SWDLocalise */
import { connectMenu } from 'instantsearch.js/es/connectors';

// create the render function
const renderMenuSelect = (renderOptions) => {
    const { items, refine, widgetParams } = renderOptions;

    if (items.length > 0) {
        widgetParams.container.innerHTML = `
            ${items.map((item) => `
                <button
                    class="flex flex-col relative p-2.5 border-2 border-transparent font-sans text-center [&.is-selected]:bg-white [&.is-selected]:border-orange${item.isRefined ? ' is-selected' : ''}"
                    data-value="${item.value}">
                    <img
                        src="${(item.label.split('||')[2] === 'server' ? SWDLocalise.homeUrl : SWDLocalise.s3Url) + item.label.split('||')[1] + (item.label.split('||')[1].includes('.webp') ? '' : '.png')}"
                        class="w-full max-w-44 h-28 xs:h-36 mb-6 mx-auto object-contain">
                    ${item.label.split('||')[0]}
                </button>
            `).join('')}
        `;

        [...widgetParams.container.querySelectorAll('button')].forEach((element) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();
                refine(event.currentTarget.dataset.value);
            });
        });
    } else {
        widgetParams.container.innerHTML = '<p>No options available for the current filter.</p>';
    }
};

// create the custom widget
const customMenuSelect = connectMenu(renderMenuSelect);

export default customMenuSelect;
